// LinkShul theme + shared visual primitives
export const COLORS = {
  purple: "#5B2A82",
  plum: "#7A2B5E",
  gold: "#C9A24B",
  goldLight: "#E2C97E",
  cream: "#FBF7F0",
  ink: "#3A2342",
  muted: "#8A7D93",
  lilac: "#F3ECF7",
  border: "#efe7f3",
};

// SVG path strings for lightweight inline icons (matching the design reference)
export const ICONS = {
  home: "M3 11l9-7 9 7M5 10v10h14V10M10 20v-6h4v6",
  clock: "M12 7v5l3 2M12 3a9 9 0 100 18 9 9 0 000-18z",
  people: "M9 11a3 3 0 100-6 3 3 0 000 6zM3 20c0-3 3-5 6-5s6 2 6 5M16 11a3 3 0 100-6M21 20c0-2.5-2-4.3-4-4.7",
  grid: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  heart: "M12 21s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 11c0 5.5-7 10-7 10z",
  bell: "M6 9a6 6 0 0112 0v5l2 2H4l2-2zM10 19a2 2 0 004 0",
  arrow: "M9 6l6 6-6 6",
  back: "M15 6l-6 6 6 6",
  shul: "M4 21V10l8-6 8 6v11M9 21v-6h6v6M12 4v3",
  mikvah: "M12 3c3 4 6 6.5 6 10a6 6 0 11-12 0c0-3.5 3-6 6-10z",
  centre: "M4 21V8l8-5 8 5v13M9 21v-5h6v5M3 21h18",
  youth: "M12 3l2 5 5 .5-4 3.5 1 5-4-3-4 3 1-5-4-3.5 5-.5z",
  book: "M5 4h13v16H6a2 2 0 00-2 2V5a1 1 0 011-1zM18 4v16",
  chesed: "M12 21s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 11c0 5.5-7 10-7 10z",
  phone: "M5 4h4l2 5-3 2a11 11 0 005 5l2-3 5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z",
  cal: "M4 6h16v15H4zM4 10h16M8 3v4M16 3v4",
  info: "M12 8h.01M11 12h1v5h1M12 3a9 9 0 100 18 9 9 0 000-18z",
  user: "M12 12a4 4 0 100-8 4 4 0 000 8zM5 21c0-4 3-6 7-6s7 2 7 6",
  chai: "M9 21V3M15 21V3M9 12h6",
  shield: "M12 3l8 3v6c0 4.5-3.5 8-8 9-4.5-1-8-4.5-8-9V6l8-3z",
  building: "M4 21V8h16v13M9 21v-6h6v6M8 12h1M15 12h1",
  sun: "M12 3v2M12 19v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M3 12h2M19 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4M12 8a4 4 0 100 8 4 4 0 000-8z",
  sparkles: "M12 3l2 5 5 2-5 2-2 5-2-5-5-2 5-2z",
  gift: "M4 8h16v13H4zM4 12h16M12 8v13M8 8a2 2 0 010-4 3 3 0 013 3v1M16 8a2 2 0 000-4 3 3 0 00-3 3v1",
  send: "M4 20l16-8L4 4l3 8-3 8z",
  chat: "M4 5h16v11H8l-4 3z",
  logout: "M15 4h3a2 2 0 012 2v12a2 2 0 01-2 2h-3M9 12h11M14 8l4 4-4 4",
  hand: "M12 21s-7-4.5-7-10a4 4 0 017-2.6A4 4 0 0119 11c0 5.5-7 10-7 10z",
};

export const iconForKey = (key) => ICONS[key] || ICONS.info;

// LinkShul mark — Star of David + tree of life (matching official logo aesthetic)
export function Mark({ size = 96, tone = "gold" }) {
  const starFill = tone === "white" ? "rgba(255,255,255,.95)" : COLORS.gold;
  const starEdge = tone === "white" ? "rgba(255,255,255,.5)" : "#A9842F";
  const leaf = tone === "white" ? "rgba(255,255,255,.7)" : "#6B2E48";
  const trunk = tone === "white" ? "rgba(255,255,255,.9)" : "#5C2E3B";
  const leaves = [[44, 40], [60, 30], [76, 40], [38, 54], [82, 54], [52, 36], [68, 36], [60, 46], [46, 62], [74, 62], [60, 58]];
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" aria-hidden="true">
      <polygon points="60,12 103,87 17,87" fill={starFill} stroke={starEdge} strokeWidth="1.5" strokeLinejoin="round" />
      <polygon points="60,108 17,33 103,33" fill={starFill} stroke={starEdge} strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M60,92 L60,58 M60,68 L48,56 M60,64 L72,52 M60,74 L70,66 M60,72 L50,66"
        stroke={trunk} strokeWidth="3.4" strokeLinecap="round" fill="none" />
      {leaves.map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r="3.2" fill={leaf} opacity={tone === "white" ? 0.8 : 0.92} />
      ))}
    </svg>
  );
}

export function Wordmark({ scale = 1, light = false }) {
  return (
    <span
      className="font-heading"
      style={{
        fontWeight: 800,
        letterSpacing: "-0.5px",
        fontSize: 26 * scale,
        lineHeight: 1,
      }}
    >
      <span style={{ color: light ? "#fff" : COLORS.purple }}>Link</span>
      <span style={{ color: light ? COLORS.goldLight : COLORS.plum }}>shul</span>
    </span>
  );
}

// Simple inline SVG icon renderer
export function Ic({ d, size = 24, color = COLORS.ink, w = 1.8 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={d} />
    </svg>
  );
}
